import { ReactNode, useEffect } from "react";
import Card from "@components/global/new/Card/Card";
import Icon from "@components/global/new/Icon/Icon";
import styles from "./Modal.module.scss";
import { IModalParams } from "@components/HOC/withModals";

import close from "@assets/icons/close.svg";

export interface ModalPropsI {
  children: ReactNode;

  handleClose(): void;

  params?: IModalParams;
}

export default function Modal({ children, handleClose, params }: ModalPropsI) {
  const onCancel = (e: KeyboardEvent) => {
    if (e.key === "Escape") handleClose();
  };
  useEffect(() => {
    document.addEventListener("keydown", onCancel);
    const html = document.querySelector("html");

    if (html) {
      html.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", onCancel);

      const html = document.querySelector("html");

      if (html) {
        html.style.overflow = "auto";
      }
    };
  }, []);
  return (
    <div className={styles.modal}>
      <div
        className={styles.wrapper}
        onClick={params?.NWC || params?.NC ? () => null : handleClose}
      />

      <Card className={styles.childrenWrapper} style={params?.style} modal>
        {!params?.NC && !params?.hideIcon && (
          <Icon
            src={close}
            className={styles.close}
            onClick={handleClose}
            noHover
          />
        )}
        {children}
      </Card>
    </div>
  );
}
